export default "__VITE_ASSET__V3z3A26T__"